import React, { useEffect, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import AboutUs from "./pages/AboutUs";


// Lazy load the Home component
const Home = React.lazy(() => import("./pages/Home"));
const TermsOfUse = React.lazy(() => import("./pages/TermsOfUse"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const CookiePolicy = React.lazy(() => import("./pages/CookiePolicy"));
const MobileAppsMonetization = React.lazy(() => import("./pages/MobileAppsMonetization"));
const AdvancedAdFormats = React.lazy(() => import("./pages/AdvancedAdFormats"));
const HeaderBidding = React.lazy(() => import("./pages/HeaderBidding"));
const AmpSolution = React.lazy(() => import("./pages/AmpSolution"));
const VideoContentCreation = React.lazy(() => import("./pages/VideoContentCreation"));
const VideoMonetization = React.lazy(() => import("./pages/VideoMonetization"));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1600,
      once: true,
    });
  }, []);

  return (
    <div>
      <Router>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/mobile-apps-monetization" element={<MobileAppsMonetization />} />
            <Route path="/advanced-ad-formats" element={<AdvancedAdFormats />} />
            <Route path="/header-bidding" element={<HeaderBidding />} />
            <Route path="/amp-solution" element={<AmpSolution />} />
            <Route path="/video-content-creation" element={<VideoContentCreation />} />
            <Route path="/video-monetization" element={<VideoMonetization />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
